module.exports = __webpack_public_path__ + "img/map-widget-illustration-1.b3e43eb5.png";